import { render, staticRenderFns } from "./customstype.vue?vue&type=template&id=32ccae91&"
import script from "./customstype.vue?vue&type=script&lang=js&"
export * from "./customstype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports